import router from "./index"
import store from '@/store'
import { getToken } from '@/utils/cookies'

const whiteRoutes = ['/', '/login', '/register', '/find-password']
router.beforeEach((to,from, next) => {
    // console.log(to, from)
    // console.log(getToken())
    if (getToken()) {
        if (!store.state.user.token) {
            store.dispatch('getLocalInfo')
        }
        // if (!store.state.user.userType && !store.state.user.userIsAuth) {
        if (!store.state.user.userIsAuth) {
            store.dispatch('getUserAuth')
            store.dispatch('setServicePhone')
        }
        if (store.state.user.userType == 0) {
            if (whiteRoutes.indexOf(to.path) !== -1) {
                next()
            } else {
                next('/login')
            }
        } else {
            if (to.path == '/login' || to.path == '/register') {
                next('/')
            } else {
                next()
            }
        }
    } else {
        if (whiteRoutes.indexOf(to.path) !== -1) {
            next()
        } else {
            next('/login')
        }
    } 
})

